import { useMemo } from "react";
import type { StripeElementsAddressElementOptions } from "../../../StripeElements/types";

export const useAddressElementFields =
  (): StripeElementsAddressElementOptions["fields"] =>
    useMemo(
      () => ({
        // We never require the phone field.
        phone: "never",
      }),
      [],
    );
